<template>
  <div v-if="menuItem && canAccessMenus(menuItem.children, permittedAuthCodes)" class="function">
    <!-- 目录 -->
    <div class="title"><i :class="menuItem.icon"></i> {{ menuItem.name }}</div>

    <!-- 子菜单的内容 -->
    <div v-for="(child, j) in menuItem.children" :key="`child-${j}`">
      <router-link v-if="canAccess(child, child.authCode, permittedAuthCodes)" :to="child.url">
        <div class="sub-fun" @click="emitCloseDrawEvent">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-html="highlineHtml(child.name, highlineText)"></span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import MenuMixin from '@/layouts/menu_mixin'

export default {
  mixins: [MenuMixin],
  props: {
    // 菜单项，包含子菜单
    menuItem: {
      type: Object,
      default: () => {}
    },
    // 高亮词
    highlineText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    /**
     * 请求关闭
     */
    emitCloseDrawEvent() {
      this.$emit('close-draw')
    },
    /**
     * 高亮文本
     *
     * @param {string} text 原文本
     * @param {string} highlineText 高亮的文本
     *  @returns {string} html
     */
    highlineHtml(text, highlineText) {
      if (this.isEmptyObject(text)) return ''
      if (this.isEmptyObject(highlineText)) return text

      const regExp = new RegExp(highlineText, 'g')
      return text.replace(regExp, `<span style="background: yellow; font-weight: bold;">${highlineText}</span>`)
    }
  }
}
</script>

<style lang="scss" scoped>
.function {
  background-color: rgb(248, 249, 250);
  border-radius: 4px;
  // width: 180px;
  // break-inside: avoid;
  margin-bottom: 10px;
  padding-bottom: 10px;
  // display: block;

  .title {
    font-size: 14px;
    color: rgb(51, 51, 51);
    font-weight: bold;
    padding: 14px 20px 5px;
  }

  .sub-fun {
    font-size: 13px;
    padding: 4px 20px;
    transition: background-color 0.2s ease-in-out 0s;
    color: rgb(102, 102, 102);
    cursor: pointer;
  }
}
</style>
